import { PublicLayoutContent } from '@components/layout/public';
import { APP_PREFIX_PATH } from '@constants/common';
import { FeedbackDialog } from '@extendedWarranty/components/FeedbackDialog';
import { ExtendedWarrantyPageHeader } from '@extendedWarranty/components/PageHeader';
import { useExtendedWarrantyContext } from '@extendedWarranty/contexts/ExtendedWarrantyContext';
import { ExportCard } from '@extendedWarranty/routes/dashboard/ActivationConfirmation';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';

const ActivationConfirmation = () => {
    const { installations } = useExtendedWarrantyContext();
    const [open, setOpen] = useState(false);

    const handleFeedbackOpen = () => {
        setOpen(true);
    };

    return (
        <PublicLayoutContent containerProps={{ className: 'relative' }}>
            <Box className="px-4 sm:px-14 pt-14 sm:pt-32" sx={{ color: (theme) => theme.palette['neutral-900'].main }}>
                <div className="flex flex-col gap-5 md:flex-row md:items-end mb-10">
                    <ExtendedWarrantyPageHeader
                        feedbackEnabled
                        title="Extended warranty upload confirmation"
                        subtitle="The upload of your serial numbers for extended warranty activation was successful, below you
                            can export a PDF file with all successfully registered serial numbers."
                        handleModalOpen={handleFeedbackOpen}
                    />
                    {false && (
                        <div className="md:ml-auto">
                            <Button
                                size="large"
                                disableElevation={false}
                                color="white"
                                className="!rounded"
                                startIcon={<EmailOutlinedIcon />}
                            >
                                <Typography fontWeight={500} variant="body1">
                                    FEEDBACK
                                </Typography>
                            </Button>
                        </div>
                    )}
                </div>
                <div className="flex flex-col gap-7">
                    {Object.keys(installations)
                        .filter((name) => installations[name].serial_numbers.length > 0)
                        .map((installation) => (
                            <ExportCard
                                key={installation}
                                {...{ name: installation, ...installations[installation] }}
                            />
                        ))}
                </div>
                <Button
                    startIcon={<SpaceDashboardOutlinedIcon />}
                    fullWidth
                    className="mt-8 rounded-sm"
                    component={Link}
                    to={`${APP_PREFIX_PATH}/extended-warranty/overview`}
                >
                    RETURN TO OVERVIEW
                </Button>
            </Box>
            <FeedbackDialog open={open} setOpen={setOpen} />
        </PublicLayoutContent>
    );
};

export { ActivationConfirmation };
